<template>
    <!-- 指派管理·组内分配水位（workOrder_v4）：按组员看未来 5 个工作日已分配素材数 / 人均产能 -->
    <div class="mw-wrap bg-white pt10 pl10 pr10 pb10 borderRadius5 mb10">
        <div class="mw-head">
            <span class="mw-title">组内分配水位</span>
            <el-select v-model="groupId" size="mini" filterable placeholder="制作组" style="width: 180px" @change="load">
                <el-option v-for="g in groups" :key="g.id" :label="g.name" :value="g.id"/>
            </el-select>
            <el-radio-group v-model="day" size="mini" :disabled="!days.length">
                <el-radio-button v-for="d in days" :key="d" :label="d">{{ d.slice(5) }}</el-radio-button>
            </el-radio-group>
            <span class="mw-sub" v-if="group.member_count">人均产能 = 组产能 ÷ {{ group.member_count }} 人（均摊估算）</span>
            <span class="mw-toggle" @click="toggle">{{ collapsed ? '展开 ▾' : '收起 ▴' }}</span>
        </div>
        <div v-show="!collapsed" v-loading="loading" class="mw-body">
            <div v-if="row" class="mw-group">
                <div class="lane-head">
                    <span class="lane-name">{{ group.name }} · {{ row.date }}</span>
                    <span class="lane-count" :class="lvl(groupTotal, row.cap + row.expand)">已分配 {{ groupTotal }} / 产能 {{ row.cap + row.expand }}{{ pctText(groupTotal, row.cap + row.expand) }}<span v-if="+row.expand" class="lane-expand">（含扩充 {{ row.expand }}）</span></span>
                </div>
                <div class="lane-bar"><i :class="lvl(groupTotal, row.cap + row.expand)" :style="{width: pct(groupTotal, row.cap + row.expand) + '%'}"></i></div>
                <div class="lane-val">
                    <span v-for="l in group.labels" :key="l.key" class="mw-lab" v-if="l.cap !== null || groupByLabel[l.key]">{{ l.key }} {{ groupByLabel[l.key] || 0 }}<template v-if="l.cap !== null">/{{ l.cap }}</template></span>
                </div>
            </div>
            <div v-if="row" class="mw-members">
                <div v-for="m in row.members" :key="m.uid" class="mw-card">
                    <div class="mw-card-head">
                        <span class="mw-name" :title="m.name">{{ m.name }}</span>
                        <span class="mw-num" :class="lvl(m.total, row.per_cap)">{{ m.total }} / 人均 {{ capText(row.per_cap) }}{{ pctText(m.total, row.per_cap) }}</span>
                    </div>
                    <div class="lane-bar mw-bar"><i :class="lvl(m.total, row.per_cap)" :style="{width: pct(m.total, row.per_cap) + '%'}"></i></div>
                    <!-- 标签逐人全列（含 0），与组头同一套 labels，便于横向对比。
                         只出已分配数：人均分母是 组产能÷人数 的均摊估算值，带小数，露出反而费解（2026-09-24）。
                         档位色仍按 per_cap 判，见 lvl()。 -->
                    <div class="mw-labs">
                        <span v-for="l in cardLabels(m)" :key="l.key" class="mw-lab" :class="lvl(l.n, l.cap)">{{ l.key }} {{ l.n }}</span>
                    </div>
                </div>
                <div v-if="!row.members.length" class="lane-empty">该组暂无在职成员</div>
            </div>
            <div v-else-if="!loading" class="lane-empty">{{ emptyText }}</div>
        </div>
    </div>
</template>
<script>
import API from '@/api/workOrder/material'
const LS_KEY = 'assign_member_water_collapsed'
export default {
    name: 'AssignMemberWater',
    data() {
        let collapsed = false
        try { collapsed = localStorage.getItem(LS_KEY) === '1' } catch (e) {}
        return { groupId: null, groups: [], days: [], day: '', rows: [], group: { labels: [] }, loading: false, collapsed, emptyText: '暂无水位数据' }
    },
    computed: {
        row() { return this.rows.find(r => r.date === this.day) || null },
        groupTotal() { return this.row ? this.row.members.reduce((s, m) => s + (+m.total || 0), 0) : 0 },
        groupByLabel() {
            const o = {}
            if (this.row) this.row.members.forEach(m => Object.keys(m.by_label || {}).forEach(k => { o[k] = (o[k] || 0) + (+m.by_label[k] || 0) }))
            return o
        },
    },
    mounted() { this.load() },
    methods: {
        reload() { this.load() },
        load() {
            this.loading = true
            API.getAssignMemberWater({ group_id: this.groupId || 0, days: 5 }).then(res => {
                const d = (res && res.data) || {}
                this.groups = d.groups || []
                this.group = d.group || { labels: [] }
                this.groupId = this.group.id || null
                this.days = d.days || []
                this.rows = d.rows || []
                if (!this.days.includes(this.day)) this.day = this.days[0] || ''
            }).catch(e => {
                this.rows = []
                this.emptyText = (e && e.info) || (e && e.message) || '暂无水位数据'
            }).finally(() => { this.loading = false })
        },
        toggle() {
            this.collapsed = !this.collapsed
            try { localStorage.setItem(LS_KEY, this.collapsed ? '1' : '0') } catch (e) {}
        },
        perCap(key) { const l = this.group.labels.find(x => x.key === key); return l && l.per_cap !== null && l.per_cap !== undefined ? l.per_cap : null },
        // 卡头人均取整展示：后端 per_cap 带 1 位小数（组产能÷人数·均摊估算），卡片只给整数档位感。
        // 仅影响文案；进度条宽度与红/黄/绿三档色仍用精确 per_cap（pct/lvl）。
        capText(v) { return v === null || v === undefined ? '-' : Math.round(v) },
        // 卡片标签：组配置过产能的标签全列（没分配也显示 0），再补该成员分配到但组未配产能的标签
        cardLabels(m) {
            const by = m.by_label || {}
            const out = this.group.labels.filter(l => l.cap !== null).map(l => ({ key: l.key, n: +by[l.key] || 0, cap: this.perCap(l.key) }))
            Object.keys(by).forEach(k => { if (!out.some(x => x.key === k)) out.push({ key: k, n: +by[k] || 0, cap: null }) })
            return out
        },
        // 三档色同排单水位：<80% 绿 / 80~100% 黄 / >100% 红（class 名 lane-full 避开全局 .full）
        lvl(used, cap) { if (!cap) return 'ok'; const r = used / cap; return r > 1 ? 'over' : r >= 0.8 ? 'lane-full' : 'ok' },
        pct(used, cap) { return cap > 0 ? Math.min(100, Math.round(used / cap * 100)) : 0 },
        pctText(used, cap) { return cap > 0 ? ` (${Math.round(used / cap * 100)}%)` : '' },
    },
}
</script>
<style scoped>
.mw-head { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.mw-title { font-weight: 600; color: #303133; font-size: 13px; }
.mw-sub { font-size: 12px; color: #909399; }
.mw-toggle { margin-left: auto; font-size: 12px; color: #409eff; cursor: pointer; }
.mw-body { margin-top: 10px; }
.mw-group { border: 1px solid #ebeef5; border-radius: 6px; padding: 8px 10px; margin-bottom: 8px; }
.lane-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px; }
.lane-name { font-weight: 600; font-size: 13px; }
.lane-count { font-size: 11px; font-weight: 600; padding: 1px 6px; border-radius: 10px; background: #f4f4f5; color: #606266; white-space: nowrap; }
.lane-count.over, .mw-num.over { color: #f56c6c; }
.lane-count.lane-full, .mw-num.lane-full { color: #e6a23c; }
.lane-count.ok, .mw-num.ok { color: #67c23a; }
.lane-bar { height: 7px; background: #f0f2f5; border-radius: 4px; overflow: hidden; position: relative; margin-bottom: 4px; }
.lane-bar > i { display: block; height: 100%; border-radius: 4px; transition: width .35s; }
.lane-bar > i.ok { background: #67c23a; }
.lane-bar > i.lane-full { background: #e6a23c; }
.lane-bar > i.over { background: #f56c6c; }
.lane-val { font-size: 11px; color: #909399; }
.lane-expand { color: #67c23a; font-weight: 600; }
.lane-empty { color: #909399; font-size: 12px; padding: 6px 0; }
.mw-lab { margin-right: 10px; }
.mw-members { display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 8px; }
.mw-card { border: 1px solid #ebeef5; border-radius: 6px; padding: 6px 10px; font-size: 12px; background: #fafafa; }
.mw-card-head { display: flex; justify-content: space-between; align-items: center; gap: 6px; margin-bottom: 4px; }
.mw-name { font-weight: 600; color: #303133; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.mw-bar { margin-bottom: 4px; }
.mw-num { font-weight: 600; white-space: nowrap; font-size: 11px; }
.mw-labs { display: flex; flex-wrap: wrap; gap: 2px 8px; color: #909399; font-size: 11px; }
.mw-labs .mw-lab { margin: 0; }
.mw-labs .mw-lab.over { color: #f56c6c; }
.mw-labs .mw-lab.lane-full { color: #e6a23c; }
</style>
